import { combineReducers } from 'redux';

import loginReducer from './login';
import loaderReducer from './loader';
import signupReducer from './signup';
import sidebarReducer from './sidebar';
import smartRoutingReducer from './smartRouting';
import settingsReducer from './settings';
import validationReducer from './validationErrors';
import paymentReducer from './payment';
import offersReducer from './offers';
import createCampaignReducer from './createcampaign';
import settlementsReducer from './settlements';
import disputesReducer from './disputes';
import refundReducer from './refund';
import overviewReducer from './overview';
import analyticsReducer from './analytics';
import paymentLinksReducer from './paymentLinks';
import MerchantListingReducer from './merchantListing';
import adminCustomRouting from './adminCustomRouting';
import payoutsReducer from './payouts';
import imeiReducer from './imei';
import planReducer from './plans';
import subscriptionReducer from './subscription';
import completeProfileReducer from './completeProfile';
import webhookEventReducer from './configureWebhook';
import transactionReducer from './edgeTransactions';
import imeiTransactionReducer from './imeiValidation';
import reportsReducer from './reports';
import partnerMerchantsReducer from './partnerMerchants';
import uiFiltersReducer from './uiFilters';
import onboardingReducer from './onboarding';
import adminTransaction from './adminTransaction';
import wallet from './wallet';

import fetchPaymentModesDataReducer from './fetchPaymentModeData';
import bpclReducer from './bpcl';
import chatbotReducer from './chatbot';
import makerCheckerReducer from './makerChecker';
import feeConfigurationReducer from './feeConfiguration';
import splitSettlementReducer from './splitSettlement';
import assistedVkycReducer from './assistedVkyc';
const reducer = combineReducers({
  loginReducer,
  loaderReducer,
  signupReducer,
  sidebarReducer,
  smartRoutingReducer,
  settingsReducer,
  validationReducer,
  paymentReducer,
  settlementsReducer,
  disputesReducer,
  refundReducer,
  overviewReducer,
  analyticsReducer,
  paymentLinksReducer,
  MerchantListingReducer,
  adminCustomRouting,
  payoutsReducer,
  imeiReducer,
  offersReducer,
  createCampaignReducer,
  planReducer,
  subscriptionReducer,
  completeProfileReducer,
  webhookEventReducer,
  transactionReducer,
  imeiTransactionReducer,
  reportsReducer,
  partnerMerchantsReducer,
  onboardingReducer,
  adminTransaction,
  wallet,
  fetchPaymentModesDataReducer,
  bpclReducer,
  chatbotReducer,
  uiFiltersReducer,
  makerCheckerReducer,
  feeConfigurationReducer,
  splitSettlementReducer,
  assistedVkycReducer,
});

export default reducer;
